// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mainContainer":"css-QxDijKVUcv"};